export default __webpack_public_path__ + "static/media/1816.bc585c1a.png";